module.exports = __webpack_public_path__ + "static/media/notification.d8d435a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/notification.mp3
// module id = 871
// module chunks = 2 6 7 38